/**
 * HorseDay REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 3.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { ReactionTypeEnum } from '../models/ReactionTypeEnum';
import { HttpFile } from '../http/http';

export class GroupDiscussionCommentReactionRequest {
    'reaction': ReactionTypeEnum;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "reaction",
            "baseName": "reaction",
            "type": "ReactionTypeEnum",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return GroupDiscussionCommentReactionRequest.attributeTypeMap;
    }

    public constructor() {
    }
}



